var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('back-btn'),_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('vlu-form',{on:{"emitData":_vm.createVolunteer}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }